/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresGetFile } from "../../funcs/llmVectorStoresGetFile.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetVectorStoreFileRequest$inboundSchema,
};

export const tool$llmVectorStoresGetFile: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-get-file",
  description: `Retrieve a vector store file

Retrieves detailed information about a specific file within a vector store.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresGetFile(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
